import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Users = lazy(() => import('./Users'));

/**
 * The Users routes.
 */
const usersRoutes: FuseRouteItemType[] = [
	{
		path: 'users',
		children: [
			{
				index: true,
				element: <Users />
			},
			{
				path: ':userId',
				element: <Users />
			}
		]
	}
];

export default usersRoutes;
